<script setup lang="ts">
import { onBeforeMount, onBeforeUnmount, onMounted, watch, computed } from 'vue';
import { useWebSocketStore, useStylesStore, useSiteStatusStore, useAuthStore } from '@/stores';
import { useRoute, useRouter } from 'vue-router';
import GlobalToast from '@/components/Toasts/GlobalToast.vue';
import BanModal from '@/components/BanModal.vue';
import SessionLimitExceedModal from '@/components/PlayerProfile/General/Limits/Time/LimitExceedModal.vue';
import DepositLimitExceed from '@/components/PlayerProfile/General/Limits/Amount/LimitExceed/DepositLimitExceed.vue';
import LossLimitExceed from '@/components/PlayerProfile/General/Limits/Amount/LimitExceed/LossLimitExceed.vue';
import WagerLimitExceed from '@/components/PlayerProfile/General/Limits/Amount/LimitExceed/WagerLimitExceed.vue';
import GetCashbackModal from '@/components/PlayerProfile/Promotions/Cashback/GetCashbackModal.vue';
import { useCurrencies } from '@/composables/useCurrencies';
import { usePublicEngagements } from '@/composables/usePublicEngagements';

import { useKYC } from '@/composables/useKYC';
import { usePlayer } from '@/composables/usePlayer';
const { toGetKYCStatus } = useKYC();
const { toGetPublicBonuses, publicBonuses } = usePublicEngagements();
const siteStatusStore = useSiteStatusStore();
const websocketStore = useWebSocketStore();
const authStore = useAuthStore();
const stylesStore = useStylesStore();
const titlePage = computed(() => stylesStore.titlePage);
const isBlocked = computed(() => siteStatusStore.isBlocked);
const isMaintenance = computed(() => siteStatusStore.isMaintenance);
const logo = computed(() => stylesStore.logo);
const route = useRoute();
const router = useRouter();
const { toGetCurrencies } = useCurrencies();
const { toUpdateLanguageCode, isPlayer, player } = usePlayer();
onBeforeMount(async () => {
    if (isBlocked.value || isMaintenance.value) {
        return;
    }
    websocketStore.initWebSocket('users', import.meta.env.VITE_USERS_SOCKET);
    if (!isPlayer.value && publicBonuses.value.bonuses.deposit.length === 0) {
        await toGetPublicBonuses();
    }
    await toGetCurrencies();
    if (isPlayer.value) {
        await toGetKYCStatus();
    }
    if (isPlayer.value && !player.value.language_code) {
        toUpdateLanguageCode();
    }
});

// hm?
onBeforeUnmount(() => {
    websocketStore.closeWebSocket('users');
});
onMounted(() => {
    watch(
        () => route.path,
        () => {
            setMetaTag('og:title', `${titlePage.value}`);
            setMetaTag('og:description', 'Description');
            setMetaTag('og:image', `${logo.value}`);
            setMetaTag('og:url', window.location.href);
            setMetaTag('iframely:title', `${titlePage.value}`);
            setMetaTag('iframely:description', 'Description');
            setMetaTag('iframely:image', `${logo.value}`);
            setMetaTag('iframely:url', window.location.href);
        },
        { immediate: true }
    );
});
function setMetaTag(property: string, content: string) {
    let tag = document.querySelector(`meta[property="${property}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
}
watch(
    () => route.query.password_reset_token,
    (newValue) => {
        if (newValue) {
            // authStore.toSetModal(true);
            if (!isPlayer.value) {
                authStore.toSetPasswordResetToken(newValue as string);
                router.push('/auth/login');
            } else {
                console.error('is already logged in');
            }
        }
    },
    { immediate: true }
);
</script>

<template>
    <template v-if="!isBlocked && !isMaintenance">
        <GlobalToast />
        <SessionLimitExceedModal />
        <DepositLimitExceed />
        <LossLimitExceed />
        <WagerLimitExceed />
        <BanModal />
        <GetCashbackModal />
    </template>
    <router-view> </router-view>
</template>
